const ROUTE_SERVICE_RULES = [
  { path: '/', requiredServiceRoute: '/', exact: true },
  { path: '/add-studiokw', requiredServiceRoute: '/' },
  { path: '/duplicate', requiredServiceRoute: '/' },
  { path: '/scheduling', requiredServiceRoute: '/scheduling' },
  { path: '/scheduled_studiokw_list', requiredServiceRoute: '/scheduling' },
  { path: '/add-scheduling', requiredServiceRoute: '/scheduling' },
  { path: '/scheduling_index', requiredServiceRoute: '/scheduling_index' },
  { path: '/scheduling_index_list', requiredServiceRoute: '/scheduling_index' },
  { path: '/add-scheduling-index', requiredServiceRoute: '/scheduling_index' },
  { path: '/market-screener', requiredServiceRoute: '/market-screener' },
  { path: '/market-screener-listing', requiredServiceRoute: '/market-screener' },
  { path: '/create-market-screener', requiredServiceRoute: '/market-screener' },
  { path: '/create-market-screener-form', requiredServiceRoute: '/market-screener' },
  { path: '/keyword-ideas', requiredServiceRoute: '/keyword-ideas' },
  { path: '/duplicate-keywords-gpt', requiredServiceRoute: '/duplicate-keywords-gpt' },
  { path: '/keyword-clustering', requiredServiceRoute: '/keyword-clustering' },
  { path: '/keyword-clustering-file', requiredServiceRoute: '/keyword-clustering' },
  { path: '/llm-visibility', requiredServiceRoute: '/llm-visibility' },
  { path: '/add-llm-visibility', requiredServiceRoute: '/llm-visibility' },
  {
    path: '/llm-visibility-scheduled',
    requiredServiceRoute: '/llm-visibility-scheduled',
  },
  {
    path: '/add-llm-visibility-scheduled',
    requiredServiceRoute: '/llm-visibility-scheduled',
  },
  {
    path: '/relevia-setup',
    requiredServiceRoute: '/llm-visibility-scheduled',
  },
  {
    path: '/add-relevia-configuration',
    requiredServiceRoute: '/llm-visibility-scheduled',
  },
  { path: '/category-text-gen', requiredServiceRoute: '/category-text-gen' },
  { path: '/add-category-text-gen', requiredServiceRoute: '/category-text-gen' },
  { path: '/ped-generator', requiredServiceRoute: '/ped-generator' },
  { path: '/ped-generator-file', requiredServiceRoute: '/ped-generator' },
  { path: '/content-gen', requiredServiceRoute: '/content-gen' },
  { path: '/content-gen-file', requiredServiceRoute: '/content-gen' },
  { path: '/lazy-load', requiredServiceRoute: '/lazy-load' },
  { path: '/bigquery-exporter', requiredServiceRoute: '/bigquery-exporter' },
  { path: '/bigquery-exporter-file', requiredServiceRoute: '/bigquery-exporter' },
  { path: '/bulk-indexing', requiredServiceRoute: '/bulk-indexing' },
  { path: '/semrush', requiredServiceRoute: '/semrush' },
  { path: '/html-cleaner', requiredServiceRoute: '/html-cleaner' },
  { path: '/monitoring-dashboard', requiredServiceRoute: '/monitoring-dashboard' },
  { path: '/seo-sentinel/site-urls', requiredServiceRoute: '/seo-sentinel/site-urls' },
  { path: '/seo-sentinel/alert-events', requiredServiceRoute: '/seo-sentinel/site-urls' },
  { path: '/seo-sentinel/email-alerts', requiredServiceRoute: '/seo-sentinel/site-urls' },
  { path: '/client-creation/clienti', requiredServiceRoute: '/client-creation/clienti' },
  { path: '/client-creation/create', requiredServiceRoute: '/client-creation/clienti' },
  { path: '/studiokw/email-alerts', requiredServiceRoute: '/scheduling' },
  { path: '/link-building/domains', requiredServiceRoute: '/link-building/domains' },
  { path: '/link-building/projects', requiredServiceRoute: '/link-building/projects' },
  { path: '/reporting', requiredServiceRoute: '/reporting' },
  { path: '/reporting-create', requiredServiceRoute: '/reporting' },
  { path: '/reporting-dimension-groups', requiredServiceRoute: '/reporting' },
  { path: '/keyword-intentions', requiredServiceRoute: '/keyword-intentions' },
  { path: '/add-keyword-intentions', requiredServiceRoute: '/keyword-intentions' },
]

const PUBLIC_PATHS = new Set(['/not-authorized'])

export const normalizePathname = (pathname = '/') => pathname || '/'

const matchesRule = (pathname, rule) => {
  if (rule.exact) {
    return pathname === rule.path
  }

  return pathname === rule.path || pathname.startsWith(`${rule.path}/`)
}

export const getRequiredServiceRoute = (pathname = '/') => {
  const normalizedPath = normalizePathname(pathname)
  const match = ROUTE_SERVICE_RULES.find((rule) => matchesRule(normalizedPath, rule))
  return match ? match.requiredServiceRoute : null
}

export const canAccessPath = ({ allowedServices = [], pathname = '/', userGroup = null }) => {
  const normalizedPath = normalizePathname(pathname)

  if (userGroup === 'Webranking' || PUBLIC_PATHS.has(normalizedPath)) {
    return true
  }

  const requiredServiceRoute = getRequiredServiceRoute(normalizedPath)
  if (!requiredServiceRoute) {
    return true
  }

  return allowedServices.some((service) => service.route === requiredServiceRoute)
}
